import { connectBaseApi, createRpcQuery, createRpcMutation, containerClient } from "@racoon/api";

export type ScheduleCreateArg = Parameters<typeof containerClient.createContainerGroupSchedule>[0];
export type ScheduleUpdateArg = Parameters<typeof containerClient.updateContainerGroupSchedule>[0];
export type SchedulePreviewArg = Parameters<typeof containerClient.previewSchedule>[0];

// Writes refresh only the schedule lists: the app no longer reads the groups' cron column, the
// one thing a mirror row's update or delete rewrites besides the row.
const containerGroupScheduleApi = connectBaseApi.injectEndpoints({
  endpoints: (build) => ({
    listContainerGroupSchedules: createRpcQuery(
      build,
      containerClient,
      "listContainerGroupSchedules",
      { providesTags: ["ContainerGroupSchedule"] },
    ),

    // Conflicts depend on the other schedules, so a schedule write refreshes the preview.
    previewSchedule: createRpcQuery(build, containerClient, "previewSchedule", {
      providesTags: ["ContainerGroupSchedule"],
    }),

    createContainerGroupSchedule: createRpcMutation(
      build,
      containerClient,
      "createContainerGroupSchedule",
      { invalidatesTags: ["ContainerGroupSchedule"] },
    ),

    updateContainerGroupSchedule: createRpcMutation(
      build,
      containerClient,
      "updateContainerGroupSchedule",
      { invalidatesTags: ["ContainerGroupSchedule"] },
    ),

    deleteContainerGroupSchedule: createRpcMutation(
      build,
      containerClient,
      "deleteContainerGroupSchedule",
      { invalidatesTags: ["ContainerGroupSchedule"] },
    ),
  }),
  overrideExisting: false,
});

export const {
  useListContainerGroupSchedulesQuery,
  useLazyListContainerGroupSchedulesQuery,
  usePreviewScheduleQuery,
  useCreateContainerGroupScheduleMutation,
  useUpdateContainerGroupScheduleMutation,
  useDeleteContainerGroupScheduleMutation,
} = containerGroupScheduleApi;
